export default __webpack_public_path__ + "static/media/brand-image-08.25813ec1.jpg";